import { useMemo } from 'react'

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons'

import { Tag } from 'antd'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

import { USERS_LETTER_STATUS } from '../../lib/constants'

function WelcomeLetterStatus({
  status = 0
}) {
  const { brandSuccess, brandDanger, brandInfo } = useTheme()
  const tag = useMemo(() => {
    switch (status) {
      case 1:
        return (
          <Tag color={brandInfo}>
            <SyncOutlined spin /> {USERS_LETTER_STATUS['1']}
          </Tag>
        )
      case 2:
        return (
          <Tag color={brandSuccess}>
            <CheckCircleOutlined /> {USERS_LETTER_STATUS['2']}
          </Tag>
        )
      case 3:
        return (
          <Tag color={brandDanger}>
            <CloseCircleOutlined /> {USERS_LETTER_STATUS['3']}
          </Tag>
        )
      default:
        return (
          <Tag color="gold">
            <ExclamationCircleOutlined /> {USERS_LETTER_STATUS['0']}
          </Tag>
        )
    }
  }, [brandDanger, brandInfo, brandSuccess, status])

  return tag
}

WelcomeLetterStatus.propTypes = {
  status: PropTypes.number,
}

export default WelcomeLetterStatus
